import React, { useState } from 'react';
import Slider from 'react-slick';
import { FILE_URLS } from '../../../constants/Common';
import { Drawer } from 'antd';
import DiamondDetail from '../../DiamondDetail';
import IntlMessages from '../../../util/IntlMessages';
import { Link } from 'react-router-dom';
import Heading from '../../common/Heading';
import camSvg from '../../../assets/svg/camera.svg';

import './FeatureStone.less';

const FeatureStone = (props) => {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState(undefined);
  var settings = {
    dots: true,
    infinite: false,
    arrows: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };
  return (
    <div className="rightBlockItem">
      <div className="d-flex j-space-between">
        <Heading title={<IntlMessages id="app.featuredStoneDashboard" />} className="p-0" />
        <Link to="/featured-stone" className="textViewAll">
          <IntlMessages id="app.viewallDashboard" />
        </Link>
        {/* <div className="rightBlockHead">
          <IntlMessages id="app.featuredStoneDashboard" />
          <Link to="/account/my-purchase" className="textViewAll">
            <IntlMessages id="app.viewallDashboard" />
          </Link>
        </div> */}
      </div>
      <div className="featuredStoneSlider">
        <Slider {...settings}>
          {props.stones &&
            props.stones.length > 0 &&
            props.stones.map((data, index) => (
              <div key={index} className="featuredStoneItem">
                <div className="featuredStoneItemBox">
                  {data.mfgStnId ? (
                    <div className="featuredStoneImage">
                      <img src={FILE_URLS.img.replace('***', data.mfgStnId)} alt="" />
                    </div>
                  ) : (
                    <div className="featuredStoneImage">
                      <img src={camSvg} alt="" />
                    </div>
                  )}
                  <div className="featuredStoneDetail">
                    <div className="detailleft">
                      <a
                        onClick={() => {
                          setVisible(true);
                          setData(data);
                        }}
                        className="featuredStoneId"
                      >
                        {data.vStnId}
                      </a>
                      <span className="featuredStonedec">{`${data.crt} ${data.colNm} ${data.clrNm}`}</span>
                      <span className="featuredStonedec">{`${data.cutNm ? data.cutNm : ''} ${data.polNm} ${
                        data.symNm
                      }`}</span>
                    </div>
                    <div className="detailRight">
                      <span className="featuredStoneShape">{data.shpNm}</span>
                      <span className="featuredStoneLab">{data.lnNm}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </Slider>
      </div>
      <Drawer visible={visible} onClose={() => setVisible(false)} wrapClassName="diamondDetailPopup" destroyOnClose>
        {visible && (
          <DiamondDetail
            data={data}
            noDetailAction={props.noDetailAction}
            onClose={() => setVisible(false)}
            diamondPopup
          />
        )}
      </Drawer>
    </div>
  );
};
export default FeatureStone;
